module.exports = __webpack_public_path__ + "static/media/male-active.4f2da460.svg";